






























import { snakeCase } from 'lodash'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import CreateNewProperty from '../../../../../../../../../../../BotProperties/components/Properties/CreateNewProperty.vue'
import {
  BotProperty, GroupedBotProperty,
} from '../../../../../../../../../../../BotProperties/components/Properties/types'
import { getPropertyTranslation } from "../../../../../../../../../../../BotProperties/utils";
import { UseFields } from '../../../../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../../../../Pi/types'
import FlowHelper from '../../../../../../../../Helpers/helper'
import { PropValueProperty } from '../../../../../logic/Actions/PropertyAction/PropertyActionValue'
import { ActionTypes } from '../../../../../logic/Actions/types'

@Component({
  data() {
    return {
      snakeCase,
      ActionTypes,
    }
  },
  components: {
    CreateNewProperty,
  }
})
export default class PropertyValueProperty extends UseFields {
  @Prop() value!: PropValueProperty

  @Prop() compatibleProperties!: Array<GroupedBotProperty>

  @Prop() createNewProperty!: (path: string, name: string, parent?: number) => Promise<Array<BotProperty> | void>

  @Watch('isOpen')
  isOpenWatcher(val: boolean): void {
    if (!val) {
      this.newPropertyName = ''
    }
  }

  newPropertyName = ''

  isOpen = false

  prepareNewProperty(option?: SelectOptionData): void {
    this.newPropertyName = option ? option.label : ''
    this.isOpen = true
  }

  setIndexInValueHandler(arg: FieldData): FieldData {
    arg.setter = (index) => this.setValuePropIndex(index)
    return arg
  }

  @Emit()
  setValuePropIndex(index: number): number {
    return index
  }

  get compatiblePropertiesOptions(): Array<SelectOptionData> {
    return this.compatibleProperties.map((p) => {
      return {
        label: getPropertyTranslation(this.$i18n, p.name ?? p.type),
        value: p.id,
        icon: {
          name: FlowHelper.getPropertyIcon(p.type),
          iconPack: 'material-icons'
        }
      }
    })
  }
}
